import { Text } from "@eo-locale/react";
export const useDaysLeft = () => {
    const getDaysLeft = (availableDay: Date): number => {
        const targetDate = new Date(availableDay)
        return Math.ceil((targetDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
    }

    const getFormattedText = (days: number): string => {

        if (days > 1) {
            return 'in_x_days'
        } else if (days === 1) {
            return 'tomorrow'
        } else if (days === 0) {
            return 'today'
        } else {
            return ''
        }
    }

    return {
        getDaysLeft,
        getFormattedText
    }
}
